import React from 'react';

function OpeningWorkspaceContent() {
  return (
    <>
      <p>The first step in using RepoPrompt is opening a workspace containing the code files you want to work with.</p>
      
      <h3>Opening a Project Folder</h3>
      <p>When you launch RepoPrompt, you'll see the main interface with the "Workspaces" section on the left:</p>
      <ol>
        <li>Click the "<strong>Open Folder</strong>" button to browse for a project directory</li>
        <li>Navigate to your desired project folder in the system dialog that appears</li>
        <li>Select the folder and click "Open"</li>
      </ol>
      
      <h3>Using Recent Workspaces</h3>
      <p>For folders you've previously opened:</p>
      <ol>
        <li>Look for the folder name in the "<strong>Recent workspaces</strong>" list</li>
        <li>Click the workspace name to open it directly</li>
      </ol>

      <p>Once opened, the folder's name will appear as the root in the file tree panel on the left, and its contents will be displayed below it.</p>

      <div className="tip-box">
        <strong>Tip:</strong> RepoPrompt remembers your workspace settings (selected files, active prompts, etc.) between sessions if you save your workspace.
      </div>
    </>
  );
}

export default OpeningWorkspaceContent;